import { Pipe, PipeTransform, inject } from '@angular/core';
import { DepositTerminologyService } from '@fitness-force/api';

@Pipe({
  name: 'depositTranslate',
  standalone: true,
  pure: false,
})
export class DepositTranslatePipe implements PipeTransform {
  private readonly depositTerminology = inject(DepositTerminologyService);

  transform(key: string, interpolateParams?: object): string {
    if (!key) {
      return '';
    }
    // Read signal so impure pipe re-evaluates when terminology changes
    this.depositTerminology.useDebitUpfront();
    return this.depositTerminology.instant(key, interpolateParams);
  }
}
